export default "__VITE_ASSET__DPB1Q01j__"